module.exports = __webpack_public_path__ + "static/img/cont38 (1).bca6100.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont38 (1).jpg
// module id = dUBZ
// module chunks = 0